import { ReactElement } from 'react';

interface CheckVerifiedProps {
  size?: number;
  color?: string;
}

export const CheckVerified = ({ color, size }: CheckVerifiedProps): ReactElement => (
  <svg width={size ?? '16'} height={size ?? '16'} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_66_111)">
      <path d="M5.99992 8.00016L7.33325 9.3335L10.3333 6.3335M4.8891 2.54596C5.42499 2.5032 5.93373 2.29247 6.3429 1.94378C7.29773 1.13007 8.7021 1.13007 9.65694 1.94378C10.0661 2.29247 10.5749 2.5032 11.1107 2.54596C12.3613 2.64575 13.3543 3.63879 13.4541 4.88934C13.4969 5.42523 13.7076 5.93397 14.0563 6.34314C14.87 7.29798 14.87 8.70235 14.0563 9.65718C13.7076 10.0664 13.4969 10.5751 13.4541 11.111C13.3543 12.3615 12.3613 13.3546 11.1107 13.4544C10.5749 13.4971 10.0661 13.7079 9.65694 14.0566C8.7021 14.8703 7.29773 14.8703 6.3429 14.0566C5.93373 13.7079 5.42499 13.4971 4.8891 13.4544C3.63855 13.3546 2.64551 12.3615 2.54572 11.111C2.50295 10.5751 2.29222 10.0664 1.94353 9.65718C1.12983 8.70235 1.12983 7.29798 1.94353 6.34314C2.29222 5.93397 2.50295 5.42523 2.54572 4.88934C2.64551 3.63879 3.63855 2.64575 4.8891 2.54596Z" stroke={color ?? '#FFFFFF'} strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_66_111">
        <rect width="16" height="16" fill={color ?? '#FFFFFF'} />
      </clipPath>
    </defs>
  </svg>
);
